interface SvgIconProps {
  svgString: string;
  className?: string;
  alt?: string;
  strokeColor?: string;
}

export function SvgIcon({
  svgString,
  className = '',
  alt = '',
  strokeColor,
}: SvgIconProps) {
  // Extract the SVG content from the string
  const extractSvgContent = (svgString: string) => {
    // Remove the outer <svg> tags and extract the inner content
    const match = svgString.match(/<svg[^>]*>(.*?)<\/svg>/s);
    if (match) {
      return match[1];
    }
    return svgString;
  };

  // Extract SVG attributes
  const extractSvgAttributes = (svgString: string) => {
    const match = svgString.match(/<svg([^>]*)>/);
    if (match) {
      const attributes = match[1];
      const attrs: Record<string, string> = {};

      // Parse common attributes
      const widthMatch = attributes.match(/width="([^"]*)"/);
      const heightMatch = attributes.match(/height="([^"]*)"/);
      const viewBoxMatch = attributes.match(/viewBox="([^"]*)"/);

      if (widthMatch) attrs.width = widthMatch[1];
      if (heightMatch) attrs.height = heightMatch[1];
      if (viewBoxMatch) attrs.viewBox = viewBoxMatch[1];

      return attrs;
    }
    return {};
  };

  const svgAttributes = extractSvgAttributes(svgString);
  const svgContent = extractSvgContent(svgString);
  const computedColor = strokeColor || 'var(--clinic-icon-stroke)';
  // Inject a style block to force stroke color on all child shapes
  const styledContent = `\n<style>* { stroke: ${computedColor} !important; }</style>\n${svgContent}`;

  return (
    <svg
      {...svgAttributes}
      className={className}
      role='img'
      aria-label={alt}
      style={{
        fill: 'none',
        stroke: computedColor,
        strokeWidth: '2',
      }}
      dangerouslySetInnerHTML={{ __html: styledContent }}
    />
  );
}
